import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="min-h-[100svh] flex items-center justify-center bg-bg-0">
        <div className="flex items-center gap-3 text-white/60">
          <span className="w-4 h-4 rounded-full border-2 border-white/20 border-t-white animate-spin" />
          <span className="font-mono text-xs tracking-[0.18em] uppercase">Loading admin…</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
}
